"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_FAILED = exports.STATUS_POTENTIAL = exports.STATUS_COMPLETED = exports.STATUS_ACTIVE = void 0;
// action status constants
exports.STATUS_ACTIVE = 1;
exports.STATUS_COMPLETED = 2;
exports.STATUS_POTENTIAL = 0;
exports.STATUS_FAILED = 3;
//# sourceMappingURL=constants.js.map